import { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LeadForm = ({ 
  source, 
  title = "Get In Touch", 
  subtitle = "",
  buttonText = "Submit",
  showMessage = true,
  showPropertyInterest = false,
  openHouseId = null,
  className = ""
}) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    property_interest: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/leads`, {
        ...formData,
        source,
        open_house_id: openHouseId
      });
      toast.success("Thank you! We'll be in touch soon.");
      setFormData({ name: '', email: '', phone: '', message: '', property_interest: '' });
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`form-section ${className}`} data-testid={`lead-form-${source}`}>
      {title && (
        <h3 className="text-2xl font-light text-[#F5F5F0] mb-2" style={{ fontFamily: 'Playfair Display' }}>
          {title}
        </h3>
      )}
      {subtitle && (
        <p className="text-[#808080] text-sm mb-6">{subtitle}</p>
      )}
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          type="text"
          placeholder="Full Name *"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          required
          className="bg-[#1A1A1A] border-[#333] text-[#F5F5F0] placeholder:text-[#808080]"
          data-testid={`${source}-name-input`}
        />
        <Input
          type="email"
          placeholder="Email Address *"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          required
          className="bg-[#1A1A1A] border-[#333] text-[#F5F5F0] placeholder:text-[#808080]"
          data-testid={`${source}-email-input`}
        />
        <Input
          type="tel"
          placeholder="Phone Number"
          value={formData.phone}
          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          className="bg-[#1A1A1A] border-[#333] text-[#F5F5F0] placeholder:text-[#808080]"
          data-testid={`${source}-phone-input`}
        />
        {showPropertyInterest && (
          <Input
            type="text"
            placeholder="Property Interest (location, type, budget)"
            value={formData.property_interest}
            onChange={(e) => setFormData({ ...formData, property_interest: e.target.value })}
            className="bg-[#1A1A1A] border-[#333] text-[#F5F5F0] placeholder:text-[#808080]"
            data-testid={`${source}-property-input`}
          />
        )}
        {showMessage && (
          <Textarea
            placeholder="Your Message"
            value={formData.message}
            onChange={(e) => setFormData({ ...formData, message: e.target.value })}
            rows={4}
            className="bg-[#1A1A1A] border-[#333] text-[#F5F5F0] placeholder:text-[#808080] resize-none"
            data-testid={`${source}-message-input`}
          />
        )}
        <Button 
          type="submit" 
          className="btn-gold w-full font-medium"
          disabled={loading}
          data-testid={`${source}-submit-btn`}
        >
          {loading ? 'Submitting...' : buttonText}
        </Button>
      </form>
    </div>
  );
};
